import { useQuery } from "@tanstack/react-query";
import { getSimilarJobs } from "app/api/job_api";

const useGetSimilarJobs = ({
  jobId,
  limit,
  offset,
  fetchCompanyLogo = true,
  staleTime = 5 * 60 * 1000,
  ...options
}) => {
  return useQuery({
    queryKey: ["similar-jobs", jobId, limit, offset, fetchCompanyLogo],
    queryFn: () => getSimilarJobs(jobId, limit, offset, fetchCompanyLogo),
    enabled: !!jobId,
    staleTime,
    ...options
  });
};

export default useGetSimilarJobs;
